var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vertical-lock"},[_c('div',[_c('h1',[_vm._v("Ooops!")]),_c('p',[_vm._v(_vm._s(_vm.$t("utils.turnScreen")))]),_c('img',{staticClass:"landscape",attrs:{"src":require("@/assets/img/utils/phone-landscape.svg")}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }